import { render, staticRenderFns } from "./BirthList.vue?vue&type=template&id=6fff8390&scoped=true&"
import script from "./BirthList.vue?vue&type=script&lang=js&"
export * from "./BirthList.vue?vue&type=script&lang=js&"
import style0 from "./BirthList.vue?vue&type=style&index=0&id=6fff8390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fff8390",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VPagination})
